var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 34,
    height: 39,
    viewBox: "0 0 34 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5133 38.2129L24.4563 29.424H9.00734L5.89571 38.2129H0L13.8112 0H19.6524L33.409 38.2129H27.5133ZM22.7094 24.4017L18.0693 11.4093C17.4142 9.62602 16.9775 8.18849 16.7591 7.09669C16.4316 8.40685 15.9948 9.84438 15.4489 11.4093L10.7542 24.4017H22.7094Z",
    fill: "#5FB4D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.2a9291f2f7e5362da5ff29256cf72ff4.svg";
export { ForwardRef as ReactComponent };